import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";

export function PointBaseConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  isPointBaseActive,
  isLoading = false,
}) {
  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[400px] p-6 bg-[#1A1A1A] text-white border border-neutral-800 rounded-2xl shadow-2xl flex flex-col items-center justify-center [&>button]:hidden">
        {/* Top Icon Box */}
        <div className="w-20 h-20 bg-[#2B2B2B] rounded-2xl flex items-center justify-center mb-4">
          {isPointBaseActive ? (
            /* Disable Icon: Red Circle with X Cross */
            <div className="w-12 h-12 rounded-full border-[3px] border-[#FF3B30] flex items-center justify-center">
              <svg
                width="16"
                height="16"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.5 1.5L12.5 12.5M12.5 1.5L1.5 12.5"
                  stroke="#FF3B30"
                  strokeWidth="2.8"
                  strokeLinecap="round"
                />
              </svg>
            </div>
          ) : (
            /* Enable Icon: Green Hand Holding Coins */
            <svg
              className="w-12 h-12 text-[#28CD41]"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17" />
              <path d="m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.8-2.8l-2.6 2.4" />
              <circle cx="16" cy="6" r="3" />
              <circle cx="11" cy="5" r="3" />
            </svg>
          )}
        </div>

        {/* Title */}
        <h2 className="text-xl font-bold text-white mb-2 text-center">
          Are yor Sure ?
        </h2>

        {/* Description Message */}
        <p className="text-sm text-neutral-300 text-center leading-relaxed mb-6 px-2">
          {isPointBaseActive
            ? "Do you want to disable this user point-based system?"
            : "Do you want to Enable this user point-based system?"}
        </p>

        {/* Action Buttons */}
        <div className="flex w-full gap-4">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 py-3 bg-[#333333] hover:bg-[#444444] text-white font-medium rounded-xl transition cursor-pointer"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={isLoading}
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className={`flex-1 py-3 ${
              isPointBaseActive
                ? "bg-[#FF3B30] hover:bg-[#E03126]"
                : "bg-[#28CD41] hover:bg-[#22B338]"
            } text-white font-medium rounded-xl transition cursor-pointer`}
          >
            {isLoading ? "Processing..." : "Yes"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default PointBaseConfirmDialog;
